import type { Identifier } from "ra-core";
import { useGetIdentity } from "ra-core";

import { isCampaignAdmin } from "../campaigns/useIsCampaignAdmin";
import type { Task } from "../types";

export const canManageTask = (
  task: Pick<Task, "sales_id">,
  identityId?: Identifier,
  canAssignOthers?: boolean,
) => {
  if (canAssignOthers) {
    return true;
  }
  if (identityId == null || task.sales_id == null) {
    return false;
  }
  return String(task.sales_id) === String(identityId);
};

export const useCanManageTask = (task: Pick<Task, "sales_id">) => {
  const { identity } = useGetIdentity();
  const canAssignOthers = isCampaignAdmin(identity);
  return canManageTask(task, identity?.id, canAssignOthers);
};
